export const ItemTypes = {
	question: "question",
};

export const NotificationTypes = {
	questionComment: "questionComment",
	link: "link",
	localLink: "localLink",
	info: "info",
	reportedErrorResponse: "reportedErrorResponse",
	questionChanged: "questionChanged",
	commentAnswer: "commentAnswer",
	commentLike: "commentLike",
	forumQuestionAnswer: "forumQuestionAnswer",
};

export const NotificationStatus = {
	waiting: "waiting",
	resolved: "resolved",
};
